import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ContactForm from './ContactForm';
import { FormattedMessage } from 'react-intl';

import mapStyle1 from '../data/GoogleMapStyle1.json';

import './Contact.css';

export default class Contact extends React.Component {

  static propTypes = {
    className: PropTypes.string
  };

  render() {
    return (
      <div className={classnames('Contact', this.props.className)}>
        <div className="Contact__content">
          <h2 className="Contact__title">
            <FormattedMessage id="Contact.title"/>
          </h2>
          <ContactForm/>
        </div>
        <div className="Contact__maps">
          <div
            className="Contact__seoulMap"
            ref={(input) => { this._seoulMapNode = input; }}
          />
        </div>
      </div>
    );
  }

  componentDidMount() {
    this._addMap(
      this._seoulMapNode,
      {
        lat: 37.5628963,
        lng: 126.9759143
      },
      {
        title: 'HANSUK INTERNATIONAL LTD.',
        line1: '서울특별시 중구 세종대로73 태평로빌딩 9층',
        line2: 'Phone: 02-756-1181~4',
        line3: 'Fax: 02-757-1133 / 1188'
      }
    );
  }

  _addMap = (mapNode, loc, address) => {
    const infowindow = new window.google.maps.InfoWindow({
      content: `
  <div class="Contact__infoWindow">
    <div class="Contact__infoTitle">${address.title}</div>
    <div class="Contact__infoLine1">${address.line1}</div>
    <div class="Contact__infoLine2">${address.line2}</div>
    <div class="Contact__infoLine3">${address.line3}</div>
  </div>
`
    });
    const map = new window.google.maps.Map(mapNode, {
      zoom: 17,
      center: loc,
      scrollwheel: false,
      disableDefaultUI: false,
      fullscreenControl: false,
      mapTypeControl: false,
      styles: mapStyle1
    });
    const marker = new window.google.maps.Marker({
      position: loc,
      map: map
    });
    marker.addListener('click', function() {
      infowindow.open(map, marker);
    });
    infowindow.open(map, marker);
  };

}



// WEBPACK FOOTER //
// ./src/components/Contact.js